import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  XMarkIcon,
  ChevronRightIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
} from "@heroicons/react/24/outline";
import { EmailOutlined, QrCode, WhatsApp } from "@mui/icons-material";
import { ColombiaIconInput } from "../../../inputs/CoIombiaIconInput";
import { DefaultInput } from "../../../inputs/DefaultInput";
import { ErroredViewDisclosure } from "../ErrorView";

export function DisclosureInviteFriendsEmail({
  handleChangeEmail,
  emailReferral,
  showError,
  messageError,
  handleSubmitEmailReferral,
  disabledBtn,
  isLoading,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 py-1">
              <div className="w-5 h-auto xl:w-6">
                <EmailOutlined />{" "}
              </div>
              <div className="pl-4">E-mail</div>
            </div>
            <div className="grid content-center">
              <ChevronRightIcon className="w-5 h-auto" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                            style={{cursor: "pointer"}}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">E-mail</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          ¿Cuál es el correo de la persona que quieres invitar?
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    <div className=" ">
                      <DefaultInput
                        value={emailReferral}
                        onChange={handleChangeEmail}
                        autoFocus={true}
                        type={"email"}
                        name={"email"}
                        id={"email"}
                        autoComplete={"on"}
                        spellCheck={true}
                        required={true}
                        minLength={"6"}
                        maxLength={"30"}
                      />
                    </div>

                    {showError && (
                      <div className="flex justify-center">
                        {" "}
                        <span className="text-sm text-red pt-2">
                          {messageError}
                        </span>{" "}
                      </div>
                    )}

                    <div className="grid justify-items-end pt-8">
                      <button
                        onClick={handleSubmitEmailReferral}
                        disabled={disabledBtn}
                        type="button"
                        className={`flex justify-center p-2 rounded-full shadow-xs text-md font-semibold text-white ${
                          disabledBtn
                            ? "bg-tgray"
                            : "bg-purple hover:bg-purpleDark"
                        } transition duration-300  focus:outline-hidden`}
                        style={{cursor: "pointer"}}
                      >
                        <div className="flex gap-2">
                          <ArrowRightIcon className="w-6 h-auto" />
                        </div>
                      </button>
                    </div>

                    {isLoading && (
                      <div
                        className="p-3 text-grayP"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div className="loader-clousure-movements"> </div>
                        </div>
                        Invitando...
                      </div>
                    )}
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export function DisclosureInviteFriendsWhatsapp({
  handleChangeWhatsapp,
  whatsappInput,
  showError,
  messageError,
  disabledBtn,
  handleSendWhatsapp,
  handleClearDisclosureWa,
}) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    handleClearDisclosureWa();
    setOpen(false);
  };

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 py-1">
              <div className="w-5 h-auto xl:w-6">
                <WhatsApp />{" "}
              </div>
              <div className="pl-4">Whatsapp</div>
            </div>
            <div className="grid content-center">
              <ChevronRightIcon className="w-5 h-auto" />
            </div>
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClose}
                            className="relative text-white focus:outline-hidden"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Whatsapp</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClose}
                            className="relative text-white focus:outline-hidden"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          ¿Cuál es el Whatsapp de la persona que quieres
                          invitar?
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    <div className=" flex">
                      <ColombiaIconInput />
                      <DefaultInput
                        value={whatsappInput}
                        onChange={handleChangeWhatsapp}
                        autoFocus={true}
                        type={"number"}
                        name={"whatsapp"}
                        id={"whatsapp"}
                        autoComplete={"on"}
                        spellCheck={true}
                        required={true}
                        minLength={1}
                        maxLength={10}
                      />
                    </div>

                    {showError && (
                      <div className="flex justify-center">
                        {" "}
                        <span className="text-sm text-red pt-2">
                          {messageError}
                        </span>{" "}
                      </div>
                    )}

                    <div className="grid justify-items-end pt-8">
                      <button
                        onClick={handleSendWhatsapp}
                        disabled={disabledBtn}
                        type="button"
                        className={`flex justify-center p-2 rounded-full shadow-xs text-md font-semibold text-white ${
                          disabledBtn
                            ? "bg-tgray"
                            : "bg-purple hover:bg-purpleDark"
                        } transition duration-300  focus:outline-hidden`}
                        style={{cursor: "pointer"}}
                      >
                        <div className="flex gap-2">
                          <ArrowRightIcon className="w-6 h-auto" />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export function DisclosureInviteFriendsQR({
  showErrorQr,
  messageErrorQr,
  isLoading,
  showQr,
  qrCode,
  handleGenerateQr,
  handleClosePanel,
}) {
  const [open, setOpen] = useState(false);

  const handleClick = async () => {
    setOpen(true);
    handleGenerateQr();
  };

  return (
    <>
      <div className={"w-full"} onClick={handleClick} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 py-1">
              <div className="w-5 h-auto xl:w-6">
                <QrCode />{" "}
              </div>
              <div className="pl-4">QR</div>
            </div>
            <div className="grid content-center">
              <ChevronRightIcon className="w-5 h-auto" />
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="relative z-50"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">QR</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          {localStorage.getItem("firstname")}, este es tu código
                          QR, compártelo con tus amigos
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    {isLoading && (
                      <div
                        className="p-3 text-grayP"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div className="loader-clousure-movements"> </div>
                        </div>
                        Generando código QR...
                      </div>
                    )}

                    {showQr && (
                      <>
                        <div className="p-4 bg-grayM rounded-3xl">
                          <div className="flex justify-center">
                            <img
                              className="h-auto rounded-t-xl"
                              src={`data:image/png;base64,${qrCode}`}
                              alt="qr-referido"
                            />
                          </div>
                          <div className="flex justify-center text-sm p-2 rounded-b-xl bg-tgray">
                            <div>
                              Encontré una entidad 100% confiable donde puedes
                              solicitar un crédito de manera segura. Usa este QR
                              para que tengas más probabilidades de tener un
                              crédito.
                              <div className="text-grayP font-bold pt-2">
                                {localStorage.getItem("firstname")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {showErrorQr && (
                      <>
                        <ErroredViewDisclosure
                          handleClosePanel={handleClosePanel}
                          showView={showErrorQr}
                          dialogTitle={"Ocurrió un error!"}
                          content={messageErrorQr}
                          redirect={"/micredito"}
                        />
                      </>
                    )}
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
